export default function IconPlay() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 70 70" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.0039 61.248C49.5014 61.248 61.2539 49.4955 61.2539 34.998C61.2539 20.5006 49.5014 8.74805 35.0039 8.74805C20.5064 8.74805 8.75391 20.5006 8.75391 34.998C8.75391 49.4955 20.5064 61.248 35.0039 61.248ZM29.172 26.2029C29.172 25.0089 30.5266 24.3192 31.4922 25.0214L43.5892 33.8192C44.3913 34.4026 44.3913 35.5988 43.5892 36.1822L31.4921 44.98C30.5266 45.6823 29.172 44.9925 29.172 43.7985V26.2029Z"
                fill="white"
            />
        </svg>
    );
}
